import { render, staticRenderFns } from "./ProductFilterDrawer.vue?vue&type=template&id=5522d28f&"
import script from "./ProductFilterDrawer.vue?vue&type=script&lang=js&"
export * from "./ProductFilterDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilterDrawer.vue?vue&type=style&index=0&id=5522d28f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports